import { Component, EventEmitter, Input, Output, } from '@angular/core';
import { HeaderPromotionComponent } from '../header-promotion/header-promotion.component';
import { HeaderNavComponent } from '../header-nav/header-nav.component';
import { HeaderLogoComponent } from '../header-logo/header-logo.component';
import { HeaderMobileMenuComponent } from '../header-mobile-menu/header-mobile-menu.component';
import { HeaderSearchComponent } from '../header-search/header-search.component';
import { HeaderCartSectionComponent } from '../header-cart-section/header-cart-section.component';
import { HeaderMyGarageSectionComponent } from '../header-my-garage-section/header-my-garage-section.component';
import { HeaderSidebarMenuComponent } from '../header-sidebar-menu/header-sidebar-menu.component';
import { ShoppingCartComponent } from '../header-cart-section/shopping-cart/shopping-cart.component';
import { CommonModule, NgClass, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { environment } from 'src/environments/environment.prod';
import { headerSetting } from 'src/_lib/interfaces/homepagesettings.interface';
import { ShopByVehicleComponent } from 'src/app/templates/shop-by-vehicle-btn/shop-by-vehicle.component';
import { AppConstants } from 'src/app/app.constants';

@Component({
  selector: 'app-header-ch2',
  templateUrl: './header-ch2.component.html',
  styleUrls: ['./header-ch2.component.scss'],
  standalone: true,
  imports: [
    HeaderPromotionComponent,
    HeaderNavComponent,
    HeaderLogoComponent,
    HeaderMobileMenuComponent,
    HeaderSearchComponent,
    HeaderCartSectionComponent,
    HeaderMyGarageSectionComponent,
    HeaderSidebarMenuComponent,
    ShoppingCartComponent,
    CommonModule,
    RouterLink,
    NgIf,
    NgClass,
    ShopByVehicleComponent
  ]
})
export class HeaderCh2Component {
  cdnImagePath: string = environment.cdnImagePath;
  showdowntooltip: boolean = true;
  isSidebarOpen: boolean;
  firstObj: number = this.appConstants.firstObj;

  @Input() headerSettings: headerSetting<string> = null;
  @Input() custom_ticker: any;
  @Input() isMobile: boolean;
  @Input() headerdata: any;
  @Input() isWishlist: boolean;
  @Input() isSticky: boolean;
  @Input() showSecondRowHeader: boolean;
  @Input() showFirstRowHeader: boolean;
  @Input() showLogo: boolean;
  @Input() showCart: boolean;
  @Input() isSearchByVehicleDisabled: boolean = false;
  @Output() scrollToTop = new EventEmitter<void>();

  onButtonClick() {
    this.scrollToTop.emit();
  }
  constructor(
    private appConstants: AppConstants
  ) { }

  onSidebarStateChange(state: boolean) {
    this.isSidebarOpen = state;
  }
}